<template lang="pug">
  b-modal#loginLogInfo(
  ref="loginLogInfoModal"
  :title="$t('ui.login_log')"
  centered
  no-fade
  ok-only
  no-enforce-focus
  size="xl"
  :busy="loading"
  @shown="reset")
    div(v-if="detail")
      div(v-if="filteredOldDetailList.length > 0")
        b-form-group(:label="$t('ui.old')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th
                      span {{ $tc('ui.providers', 1) }}
                    th
                      span {{ $t('ui.url') }}
                    th
                      span {{ $t('ui.username') }}
                    th
                      span {{ $t('ui.password') }}
                    th(width=100).text-center
                      span {{ $t("ui.disabled") }}
                    th
                      span {{ $t("ui.fullname") }}
                    th
                      span {{ $t("ui.status") }}
                    th.text-right(width=200)
                      span {{ $t("ui.created_on") }}
                tbody
                  tr(v-for="item in filteredOldDetailList")
                    td
                      span {{ item.provider_id }}
                    td
                      b-link(:href="item.host_url") {{ item.host_url }}
                    td
                      span {{ item.login_id }}
                    td
                      span {{ item.password }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.login_disabled, 'fas fa-times text-warning': !item.login_disabled  }")
                    td
                      span {{ item.login_name }}
                    td
                      span {{ item.status }}
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
      div(v-if="filteredNewDetailList.length > 0")
        b-form-group(:label="$t('ui.new')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th
                      span {{ $tc('ui.providers', 1) }}
                    th
                      span {{ $t('ui.url') }}
                    th
                      span {{ $t('ui.username') }}
                    th
                      span {{ $t('ui.password') }}
                    th(width=100).text-center
                      span {{ $t("ui.disabled") }}
                    th
                      span {{ $t("ui.fullname") }}
                    th
                      span {{ $t("ui.status") }}
                    th.text-right(width=200)
                      span {{ $t("ui.created_on") }}
                tbody
                  tr(v-for="item in filteredNewDetailList")
                    td
                      span {{ item.provider_id }}
                    td
                      b-link(:href="item.host_url") {{ item.host_url }}
                    td
                      span {{ item.login_id }}
                    td
                      span {{ item.password }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.login_disabled, 'fas fa-times text-warning': !item.login_disabled  }")
                    td
                      span {{ item.login_name }}
                    td
                      span {{ item.status }}
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    detail: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      recordList: []
    };
  },
  computed: {
    filteredOldDetailList() {
      if (this.recordList.length > 0) {
        return this.recordList.filter((item) => {
          return item.type.toLowerCase() == 'old';
        });
      } else
        return [];
    },
    filteredNewDetailList() {
      if (this.recordList.length > 0) {
        return this.recordList.filter((item) => {
          return item.type.toLowerCase() == 'new';
        });
      } else
        return [];
    },
  },
  methods: {
    getRecord() {
      let url = config.auditLogDetailRecordUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.auditlog,
        log_id: this.detail.log_id,
        log_detail_id: this.detail.log_detail_id,
        audit_table_name: this.detail.audit_table_name
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.recordList = response.data.tbl_audit_log_detail_record;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset() {
      this.getRecord();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
